import { Injectable } from '@angular/core';
import { BehaviorSubject, ReplaySubject } from 'rxjs';

import { LegacyTask } from '../legacy-task/legacy-task';
import { LegacyTasksStore } from './legacy-tasks-store.service';

@Injectable({
    providedIn: 'root'
})
export class LegacyTasksStreamsService {
    // --------------
    // Map Workspace tasks streams

    visibleTasksStream = new BehaviorSubject<LegacyTask[]>([]);
    private selectedTasksStream = new BehaviorSubject<LegacyTask[]>([]);
    loadTaskStream = new ReplaySubject<LegacyTask>(1);
    pendingLoadingTaskStream = new BehaviorSubject<{ task: LegacyTask; loading: boolean }>(null);
    deferVisibleTasksStream = new BehaviorSubject<LegacyTask[]>([]);
    deferHideTasksStream = new BehaviorSubject<LegacyTask[]>([]);
    mapWorkspaceTasksStream: BehaviorSubject<LegacyTask[]>;

    constructor(private tasksStore: LegacyTasksStore) {
        // ! GIM 20/5/2019 - This line used to have a shareReplay on it, but the underlying
        // ! observable is a BehaviourSubject so not applicable
        this.mapWorkspaceTasksStream = tasksStore.mapWorkspaceTasksStream;
    }

    public setVisibleTasks(tasks: LegacyTask[]): void {
        this.visibleTasksStream.next(tasks);
    }

    public setSelectedTasks(tasks: LegacyTask[]): void {
        this.selectedTasksStream.next(tasks);
    }

    public setSelectedTodos(todoIds: string[]): void {
        this.tasksStore.isTasksLoaded().then(() => {
            this.tasksStore.mapWorkspaceTasksStream.getValue().forEach(task => {
                if (todoIds.indexOf(task.todoId) !== -1) {
                    this.loadTaskStream.next(task);
                }
            });
        });
    }

    public setTaskAsLoading(task: LegacyTask): void {
        this.pendingLoadingTaskStream.next({ task: task, loading: true });
    }

    public setTaskAsLoaded(task: LegacyTask): void {
        this.pendingLoadingTaskStream.next({ task: task, loading: false });
    }
}
